import { FetchBaseQueryArgs } from '@reduxjs/toolkit/query';
import { fetchWithCause, paramsSerializer } from './libs';
import { GlobalConfig } from './types';

export const defaultQueryOptions: FetchBaseQueryArgs = {
  paramsSerializer,
  fetchFn: fetchWithCause,
};

export let globalConfig: GlobalConfig = {
  defaultQueryOptions: defaultQueryOptions,
  getQueryOptions: () => defaultQueryOptions,
  errorHandler: (action) => {
    if (action.payload.status === 'FETCH_ERROR') {
      console.error('Failed to access the API:', JSON.stringify(action.payload), JSON.stringify(action.meta));
      return;
    }

    if (action.payload.status < 500) {
      // 4xx errors should be handled by the call site
      return;
    }

    console.error('Query error:', JSON.stringify(action.payload), JSON.stringify(action.meta));
  },
};

export const initialize = (config: GlobalConfig) => {
  globalConfig = {
    ...globalConfig,
    ...config,
  };
};
